/*
 * Homepage search bar - behaviour only.
 *
 * The bar and the result rows are rendered by sections/homepage-search.liquid.
 * Results come from Shopify's search index through the Section Rendering API,
 * so this file fetches markup, not data: there is no catalogue to download, no
 * Storefront token, and no relevance scoring to do in the browser.
 *
 * Ported from the Variant experience exp-EXPC4697DC8.
 */
(function () {
  'use strict';

  var MIN_QUERY_LENGTH = 2;
  var DEBOUNCE_MS = 300;

  function init(root) {
    if (root.dataset.searchReady) return;
    root.dataset.searchReady = '1';

    var section = root.closest('.shopify-section');
    var form = root.querySelector('[data-search-form]');
    var input = root.querySelector('[data-search-input]');
    var dropdown = root.querySelector('[data-search-dropdown]');
    if (!section || !form || !input || !dropdown) return;

    var settings = readSettings(section);
    var sectionId = section.id.replace('shopify-section-', '');
    var debounceTimer = null;
    var lastQuery = '';
    var requestToken = 0;

    function track(action, extra) {
      if (!settings.analytics) return;
      try {
        if (typeof Variant === 'undefined' || !Variant.publishCustomEvent) return;
        var payload = {
          experiment_id: settings.experimentId,
          variation_id: settings.variationId
        };
        for (var key in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, key)) payload[key] = extra[key];
        }
        Variant.publishCustomEvent(action, payload);
      } catch (e) {
        /* never break the page for analytics */
      }
    }

    // -----------------------------------------------------------------------
    // Results
    // -----------------------------------------------------------------------
    function closeDropdown() {
      dropdown.hidden = true;
      dropdown.innerHTML = '';
      lastQuery = '';
    }

    function search(query) {
      if (query === lastQuery) return;
      lastQuery = query;

      dropdown.innerHTML = '<p class="homepage-search__loading">' + settings.loadingText + '</p>';
      dropdown.hidden = false;

      var token = ++requestToken;
      var url =
        (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') +
        // unavailable_products=hide matches the original, which only ever
        // considered products that were available for sale.
        'search?type=product&options[prefix]=last&options[unavailable_products]=hide&q=' +
        encodeURIComponent(query) +
        '&section_id=' +
        sectionId;

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          // A slower earlier request must not overwrite a newer one.
          if (token !== requestToken) return;
          if (input.value.trim() !== query) return;

          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var results = parsed.querySelector('[data-search-results]');
          if (!results) {
            closeDropdown();
            return;
          }

          dropdown.innerHTML = results.innerHTML;
          dropdown.hidden = false;
        })
        .catch(function () {
          if (token === requestToken) closeDropdown();
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var query = input.value.trim();

      if (query.length < MIN_QUERY_LENGTH) {
        closeDropdown();
        return;
      }

      debounceTimer = setTimeout(function () {
        search(query);
      }, DEBOUNCE_MS);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeDropdown();
      input.blur();
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeDropdown();
    });

    // The links navigate on their own; the events are sent alongside rather
    // than the original's cancel-track-then-navigate dance, which left nothing
    // any time to send.
    dropdown.addEventListener('click', function (event) {
      var result = event.target.closest('[data-search-result]');
      if (result) {
        track('product-clicked-attribution', { product_id: result.getAttribute('data-product-id') });
        return;
      }

      if (event.target.closest('[data-search-view-all]')) {
        track('influenced-revenue', { action: 'search_view_all', query: input.value.trim() });
      }
    });

    form.addEventListener('submit', function (event) {
      var query = input.value.trim();
      if (!query) {
        event.preventDefault();
        return;
      }
      track('influenced-revenue', { action: 'search_submit', query: query });
    });

    // -----------------------------------------------------------------------
    // Typed placeholder
    // -----------------------------------------------------------------------
    var suggestions = (input.getAttribute('data-suggestions') || '')
      .split('\n')
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean);

    var focusPlaceholder = input.getAttribute('data-focus-placeholder') || '';
    var typing = { active: false, order: [], index: 0, chars: 0, deleting: false, timer: null };

    function shuffle(list) {
      var copy = list.slice();
      for (var i = copy.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var swap = copy[i];
        copy[i] = copy[j];
        copy[j] = swap;
      }
      return copy;
    }

    function typeStep() {
      if (!typing.active || !typing.order.length) return;
      var word = typing.order[typing.index % typing.order.length];

      if (!typing.deleting) {
        typing.chars++;
        if (typing.chars >= word.length) {
          input.setAttribute('placeholder', word);
          typing.timer = setTimeout(function () {
            typing.deleting = true;
            typeStep();
          }, 2200);
          return;
        }
        input.setAttribute('placeholder', word.substring(0, typing.chars) + '|');
        typing.timer = setTimeout(typeStep, 90 + Math.random() * 50);
        return;
      }

      typing.chars--;
      if (typing.chars <= 0) {
        input.setAttribute('placeholder', '|');
        typing.deleting = false;
        typing.index++;
        if (typing.index % typing.order.length === 0) typing.order = shuffle(suggestions);
        typing.timer = setTimeout(typeStep, 400);
        return;
      }
      input.setAttribute('placeholder', word.substring(0, typing.chars) + '|');
      typing.timer = setTimeout(typeStep, 45 + Math.random() * 25);
    }

    function startTyping() {
      if (!suggestions.length) return;
      typing.active = true;
      typing.order = shuffle(suggestions);
      typing.chars = 0;
      typing.deleting = false;
      typeStep();
    }

    function stopTyping() {
      typing.active = false;
      clearTimeout(typing.timer);
    }

    var focusTracked = false;

    input.addEventListener('focus', function () {
      stopTyping();
      input.setAttribute('placeholder', focusPlaceholder);

      if (focusTracked) return;
      focusTracked = true;
      track('influenced-revenue', { action: 'search_focus' });
    });

    input.addEventListener('blur', function () {
      if (input.value.trim() !== '') return;
      setTimeout(function () {
        if (dropdown.hidden) {
          typing.index++;
          startTyping();
        }
      }, 150);
    });

    // Respect visitors who asked for less motion.
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion) startTyping();

    // -----------------------------------------------------------------------
    // Impression
    // -----------------------------------------------------------------------
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            track('influenced-revenue', { action: 'search_bar_view' });
            observer.disconnect();
          });
        },
        { threshold: 0.5 }
      );
      observer.observe(root);
    }
  }

  function readSettings(section) {
    var script = section.querySelector('[data-homepage-search-settings]');
    var parsed = {};
    try {
      parsed = JSON.parse(script.textContent);
    } catch (e) {
      /* fall through to defaults */
    }
    return {
      analytics: parsed.analytics !== false,
      experimentId: parsed.experiment_id || '',
      variationId: parsed.variation_id || '',
      loadingText: parsed.loading_text || '...'
    };
  }

  function boot() {
    var root = document.querySelector('[data-homepage-search]');
    if (root) init(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
